import { memo, useEffect, useState } from 'react';

import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { IoMdInformationCircleOutline } from '@react-icons/all-files/io/IoMdInformationCircleOutline';
import { Button } from '@core/design-system/button';
import Link from 'next/link';
import { marketData } from '@core/market-data-sdk';

export const MutualFundsDisclaimer = memo<FiiDisclaimerProps>(
  ({ fundSlug, fiType }) => {
    const [isMutualSheet, setIsMutualSheet] = useState(false);
    const [buttonUrl, setButtonUrl] = useState('');

    const cleanSlug = fundSlug?.replace(/[.-\/]/g, '');

    const fundSearch = async () => {
      const funds = await marketData.general.search(cleanSlug);

      const mutualFunds = funds.filter(
        (fund) => fund.type.includes('Fundo') || fiType
      );

      setIsMutualSheet(mutualFunds.length > 1);

      if (fiType !== 'Fundo') {
        const url = mutualFunds?.find((fund) =>
          fund.type?.includes('Fundo')
        )?.canonical_url;

        setButtonUrl(url);
        return;
      }
      const url = mutualFunds?.find(
        (fund) => fund.type !== fiType
      )?.canonical_url;

      setButtonUrl(url);
    };

    useEffect(() => {
      fundSearch();
    }, [fundSlug, fiType]);

    if (!isMutualSheet) return null;

    return (
      <Stack
        p={[1, 2, 1, 2]}
        bgcolor="#DCEFF7"
        direction="row"
        width="100%"
        justifyContent="space-between"
        alignItems="center"
        borderRadius={2}
        flexWrap="wrap"
        displayPrint="none"
      >
        <Stack direction="row" gap={2} alignItems="center" maxWidth="70%">
          <Avatar sx={{ width: '24px', height: '24px', bgcolor: '#DCEFF7' }}>
            <IoMdInformationCircleOutline size={18} color="#0057FF" />
          </Avatar>
          <Typography variant="body2" fontWeight={400}>
            <strong>Importante: </strong> Essa página representa as informações
            públicas do fundo considerando a
            <strong>
              {fiType !== 'Fundo'
                ? ' cota negociada a mercado na b3'
                : ' cota patrimonial'}
            </strong>
            {fiType === 'Fundo' &&
              ' e os dados abertos pela regulação ICVM 555'}
            . Para ver os dados{' '}
            {fiType !== 'Fundo'
              ? 'da cota patrimonial e os dados cadastrais abertos pela ICVM 555'
              : ' da cota a mercado listada na bolsa'}
            , clique aqui para acessar a lâmina.
          </Typography>
        </Stack>

        <Button
          LinkComponent={Link}
          component="a"
          variant="outlined"
          color="primary"
          href={`https://maisretorno.com/${buttonUrl}`}
          sx={{ textTransform: 'none', borderRadius: '24px' }}
        >
          Ver lâmina
        </Button>
      </Stack>
    );
  }
);

interface FiiDisclaimerProps {
  fundSlug: string;
  fiType: string;
}
